import Vue from 'vue'

import * as VueGoogleMaps from '~/node_modules/vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: { key: 'AIzaSyCbW4B0ULfuL-T6NYMigRP28oIlRga04aE' },
  installComponents: true
})
